import { RecordingType } from '@ftr/contracts/type/recording'
import { Uuid } from '@ftr/contracts/type/shared'
import { AppPaths } from './app.paths'
import { CourtSystemPaths } from './court-system.paths'
import { RecordingPlaybackPaths } from './recording-playback.paths'

export function getRecordingPath(
  courtSystemId: Uuid,
  recordingId: Uuid,
  recordingType: RecordingType = RecordingType.TRM,
  relative = false,
): string[] {
  return [
    relative ? undefined : '/',
    AppPaths.CourtSystem,
    courtSystemId,
    CourtSystemPaths.RecordingPlayback,
    recordingType === RecordingType.TRM ? undefined : RecordingPlaybackPaths.StreamRecording,
    recordingId,
  ].filter((x): x is string => x !== undefined && x !== null)
}
